interface SectionHeadingProps {
  eyebrow?: string
  title: string
  description?: string
  align?: 'left' | 'center'
}

export function SectionHeading({ eyebrow, title, description, align = 'center' }: SectionHeadingProps) {
  return (
    <div className={`section-heading align-${align}`}>
      {eyebrow && <span className="eyebrow reveal">{eyebrow}</span>}
      <h2 className="section-title reveal delay-1">{title}</h2>
      {description && <p className="section-desc reveal delay-2">{description}</p>}
    </div>
  )
}
